import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Returns a sinister to ES status
 *
 * @param  payload File and id
 * @return {Array} File's info
 */

const returnToPT = payload =>
  Vue.$http.post('workplan/return-to/PT/', payload)
    .then()
    .catch((err) => {
      throw err
    })

export default returnToPT


// WEBPACK FOOTER //
// ./src/services/workPlan/returnToPT.js